<template>
  <div id="live-map-vessel-detail-camera-view">
    <vx-card class="overflow-hidden">
      <template slot="no-body">
        <div class="live-camera-area">
          <P>{{ cameraMsg }}</P>
          <vs-button
            v-if="hasVideoError"
            icon-pack="feather"
            icon="icon-rotate-cw"
            color="rgb(255, 255, 255)"
            type="line"
            size="small"
            @click="connect"
            >{{ retryText }}</vs-button
          >
          <video-player
            v-show="hasCamera"
            ref="videoPlayer"
            class="media-video-player card-video vjs-custom-skin vjs-big-play-centered camera"
            :options="playerOption"
            @ready="onPlayerReadied"
            @play="onPlayerPlay"
            @pause="onPlayerPause"
            @error="onPlayerError"
          />
          <div v-show="!hasCamera" class="example">
            <div class="vessel-camera-bg" />
          </div>
        </div>
      </template>
    </vx-card>
  </div>
</template>

<script>
import { videoPlayer } from "vue-videojs7";
import videojs from "video.js";
import { AiseaApiFactory } from "@/api/aisea/apiFactory";

// Mixin
import { CameraMixin } from "@/mixins";

export default {
  components: {
    videoPlayer
  },
  props: {
    camera: { type: Object, default: null }
  },
  mixins: [CameraMixin],
  data() {
    return {
      initialized: false,
      hasVideoError: false,
      isConnecting: false,
      hasCamera: false,
      errorDisplay: null,
      cameraMsg: "",
      retryText: ""
    };
  },
  watch: {
    camera: {
      immediate: true,
      handler() {
        if (this.camera.id !== "0") {
          this.connect();
        } else {
          this.cameraMsg = "No camera";
        }
      }
    }
  },
  computed: {
    player() {
      if (typeof this.$refs.videoPlayer === "undefined") return null;
      return this.$refs.videoPlayer.player;
    },
    playerOption() {
      return this.getPlayerOption(this.camera.movie_type);
    }
  },
  methods: {
    onPlayerReadied() {
      this.initialized = true;
    },

    onPlayerPlay() {
      this.hidePlayButton();
    },

    onPlayerError() {
      this.cameraMsg = "";
      this.retryText = "もう一度接続";
      this.hidePlayButton();
      this.hasVideoError = true;
    },

    onPlayerPause() {
      this.showPlayButton();
    },

    async connectToCamera() {
      try {
        let res = await AiseaApiFactory.get("enterpriseCamera").connect(
          this.camera.id
        );
        return res.data.url;
      } catch (e) {
        return null;
      }
    },

    async connectToHlsCamera() {
      try {
        let res = await AiseaApiFactory.get("enterpriseCamera").connectHLS(
          this.camera.id
        );
        return res.data.url;
      } catch (e) {
        return null;
      }
    },

    async connect() {
      if (this.initialized) {
        await this.cleanup();
      }
      this.cameraMsg = "カメラに接続中...";

      let url
      if( this.camera.movie_type === this.CAMERA_MOVIE_TYPE.HLS_CAMERA || this.camera.movie_type === this.CAMERA_MOVIE_TYPE.MEDIAMTX ){
        url = await this.connectToHlsCamera();
        if (url) {
          this.playVideoHls(url);
        } else {
          this.errorHandler();
        }
      } else {
        let url = await this.connectToCamera();
        if (url) {
          this.playVideo(url);
        } else {
          this.errorHandler();
        }
      }
    },

    errorHandler() {
      if (this.player) {
        this.player.reset();
        let ErrorDisplay = videojs.getComponent("ErrorDisplay");
        this.errorDisplay = new ErrorDisplay(this.player, {
          temporary: false
        });
        this.player.addChild(this.errorDisplay);
        this.cameraMsg = "";
        this.player.error(
          this.getCameraErrorMessage(this.camera.movie_type)
        );
        this.retryText = "もう一度接続";
        this.hasVideoError = true;
        this.hasCamera = true;
      }
    },

    async cleanup() {
      this.retryText = "";
      this.hasVideoError = false;
      this.hidePlayButton();
      if (this.player) {
        this.player.error(null);
        this.player.removeChild(this.errorDisplay);
        this.player.reset();
      }
    },

    playVideo(bassUrl) {
      if (this.player) {
        this.hasCamera = true;
        this.cameraMsg = "";
        this.player.reset();
        const video = {
          withCredentials: false,
          type: "application/x-mpegurl",
          src: bassUrl + "/webcam/hls/stream.m3u8"
        };
        this.player.src(video);
        this.player.poster(bassUrl + "/webcam/thumbnail/thumbnail.png");
        this.showPlayButton();
      }
    },

    playVideoHls(bassUrl) {
      if (this.player) {
        this.hasCamera = true;
        this.cameraMsg = "";
        this.player.reset();
        const video = {
          withCredentials: false,
          type: "application/x-mpegurl",
          src: bassUrl
        };
        this.player.src(video);
        let path = bassUrl.split("/")
        path.pop()
        this.player.poster(path.join("/") + "/thumbnail.png");
        this.showPlayButton();
      }
    },

    hidePlayButton() {
      let playButton = this.player
        .contentEl()
        .getElementsByClassName("vjs-big-play-button");
      playButton[0].style.display = "none";
    },

    showPlayButton() {
      let playButton = this.player
        .contentEl()
        .getElementsByClassName("vjs-big-play-button");
      playButton[0].style.display = "block";
    }
  },
  created() {}
};
</script>

<style lang="scss">
#live-map-vessel-detail-camera-view {
  .video-js .vjs-big-play-button {
    display: none;
  }
  .vjs-modal-dialog-content {
    font-size: 1.2em;
  }
  .vs {
    &__dropdown-menu {
      max-height: 150px !important;
    }
  }
  .live-camera-area {
    position: relative;
  }
  .live-camera-area p {
    position: absolute;
    top: 50%;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    margin: 0;
    padding: 0;
    color: white;
    z-index: 5;
  }
  .live-camera-area .vs-component {
    z-index: 5;
    position: absolute;
    top: 80%;
    left: 50%;
    -ms-transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }
  .vessel-camera-bg {
    width: 100%;
    height: 140px;
    background: black;
  }
}
</style>
